import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton, UiText } from '@shared/ui';

import cls from './ModalTeamProject.module.css';
import { ModalTeamProjectBody } from './ModalTeamProjectBody/ModalTeamProjectBody';
import { useModalTeamProject } from './useModalTeamProject';

interface ModalTeamProjectProps {
    classes?: string;
}

export const ModalTeamProject = memo(({ classes }: ModalTeamProjectProps) => {
    const { modalMode, onHideModal } = useModalTeamProject();

    const { t } = useTranslation();

    return (
        <CustomModal
            contentClasses={cls.ModalTeamProject}
            isOpen={modalMode === 'teamProject'}
            onHideModal={onHideModal}
        >
            <CustomModal.Header>
                <Flex direction="column" align="start" gap={10}>
                    {t('ModalTeamProject.return.ModalHeader.text')}
                    <div className={cls.subtitle}>
                        <UiText variant="mediumPlain">
                            {t('AddProject.return.Modal.ModalHeader.subtitle')}
                        </UiText>
                    </div>
                </Flex>
            </CustomModal.Header>
            <CustomModal.Body>
                <ModalTeamProjectBody />
            </CustomModal.Body>
            <CustomModal.Footer>
                <UiButton btnText={t('button.ready.text')} onClick={onHideModal} />
            </CustomModal.Footer>
        </CustomModal>
    );
});
